module.exports = __webpack_public_path__ + "static/media/user-35.6bbcd3a0.png";